/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_AddInputs */

const vi_camera_station_add = /** @type {(inputs: Camera_Station_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm camera mới cho trạm`)
};

/**

* @param {Camera_Station_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_add = /** @type {((inputs?: Camera_Station_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_add(inputs)
});